import React from 'react';
import { List, ListItem, Typography } from '@mui/material';
import { resolveSafeHref } from './RestrictedMarkdown';

// Numbered citation sources (OWASP LLM05): every href goes through resolveSafeHref and
// the link text is the full URL; an unsafe URL renders no anchor and no URL text.
export default function CitationsPanel({ citations }) {
  if (!Array.isArray(citations) || citations.length === 0) return null;

  return (
    <List component="ol" dense disablePadding data-testid="ai-citations-panel" className="ai-citations-panel">
      {citations.map((c, idx) => {
        const label = c?.title || c?.sourceId;
        const safeHref = resolveSafeHref(c?.url);
        return (
          <ListItem key={`${c?.sourceId || 'citation'}-${idx}`} disableGutters data-testid="ai-citation" sx={{ display: 'block' }}>
            <Typography component="span" variant="body2">{`[${idx + 1}]`}</Typography>
            {label && <Typography component="span" variant="body2"> {label}</Typography>}
            {safeHref && (
              <>
                {' '}
                <a href={safeHref} target="_blank" rel="noopener noreferrer">
                  {safeHref}
                </a>
              </>
            )}
          </ListItem>
        );
      })}
    </List>
  );
}
